export default __webpack_public_path__ + "static/media/DEPRESSIONE_ICONA .d88e5285.svg";